import { JSONable } from '@irian-ro/abstract-resource';

export class EtransportModifVehicleDtoModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  eTransportNotificationUuid: string | null = null;
  uit: string | null = null;
  licensePlate: string | null = null;
  firstTrailerLicensePlate: string | null = null;
  secondTrailerLicensePlate: string | null = null;
  modificationDate: string | null = null;
  observations: string | null = null;
}
